module.exports = __webpack_public_path__ + "img/icon-trailer.26b3cb75.svg";